import { apiClient } from "@/api/api-client";

export type BomBrand = {
    id: number;
    brand_name: string;
};

const bomBrandService = {
    list: async (): Promise<BomBrand[]> => {
        const response = await apiClient.get<BomBrand[]>("/bom/brands");
        return response.data;
    },
};

export default bomBrandService;
